export const changelog = [
    {
        version: '0.1.0',
        date: '2023-06-06',
        title: 'New Change Log',
        changes: `- Changelog is now available\n - Fixing cs api is using employee id \n - fixing qc api using employee id \n - fixing missing variable on table`
    }
]